import React, { useState, useEffect, useRef } from 'react';
import { getBatches, createBatch, updateBatch, deleteBatch, archiveBatch, getScenarios } from '../services/api';

const NUM_DAYS = 10;

function makeEmptyDays() {
  return Array.from({ length: NUM_DAYS }, (_, i) => ({
    day_number: i + 1,
    name: `Day ${i + 1}`,
    assigned_scenario_ids: [],
    graded_scenario_ids: [],
    training_date: '',
  }));
}

function todayAZString() {
  // Arizona is UTC-7 year-round (no DST)
  const now = new Date();
  const az = new Date(now.getTime() - 7 * 60 * 60 * 1000);
  return az.toISOString().slice(0, 10);
}

const styles = {
  heading: { fontSize: '24px', fontWeight: '700', color: '#1a202c', marginBottom: '24px' },
  toolbar: { display: 'flex', gap: '12px', marginBottom: '24px' },
  addBtn: {
    padding: '10px 20px', background: '#9C3D97', color: '#fff', border: 'none',
    borderRadius: '6px', fontSize: '14px', fontWeight: '600', cursor: 'pointer',
  },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
  th: { padding: '12px 16px', textAlign: 'left', background: '#f7fafc', fontSize: '12px', fontWeight: '600', color: '#718096', textTransform: 'uppercase', letterSpacing: '0.5px' },
  td: { padding: '12px 16px', borderTop: '1px solid #e2e8f0', fontSize: '14px', color: '#4a5568' },
  badge: { padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' },
  badgeActive: { background: '#c6f6d5', color: '#276749' },
  badgeClosed: { background: '#fed7d7', color: '#c53030' },
  actionBtn: {
    padding: '6px 12px', border: '1px solid #e2e8f0', borderRadius: '4px',
    background: '#fff', fontSize: '13px', cursor: 'pointer', marginRight: '8px',
  },
  modal: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
  },
  modalCard: { background: '#fff', borderRadius: '12px', padding: '32px', width: '720px', maxHeight: '85vh', overflow: 'auto' },
  modalTitle: { fontSize: '20px', fontWeight: '700', marginBottom: '20px' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#4a5568', marginBottom: '6px', marginTop: '16px' },
  required: { color: '#e53e3e', marginLeft: '2px' },
  input: { width: '100%', padding: '10px 14px', border: '2px solid #e2e8f0', borderRadius: '6px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  select: { width: '100%', padding: '10px 14px', border: '2px solid #e2e8f0', borderRadius: '6px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', background: '#fff' },
  modalActions: { display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' },
  cancelBtn: { padding: '10px 20px', background: '#edf2f7', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  saveBtn: { padding: '10px 20px', background: '#9C3D97', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  saveBtnDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  success: { background: '#c6f6d5', color: '#276749', padding: '12px', borderRadius: '6px', marginBottom: '16px', fontSize: '14px' },
  error: { background: '#fed7d7', color: '#c53030', padding: '12px', borderRadius: '6px', marginBottom: '16px', fontSize: '14px' },
  dayHeader: {
    display: 'flex', alignItems: 'center', gap: '12px',
    padding: '10px 14px', background: '#f7fafc', borderRadius: '6px',
    cursor: 'pointer', marginBottom: '2px', userSelect: 'none',
    border: '1px solid #e2e8f0',
  },
  dayHeaderGrading: { background: '#f0e6f0', borderColor: '#d6b3d6' },
  dayHeaderLocked: { background: '#edf2f7', borderColor: '#cbd5e0', opacity: 0.85 },
  dayName: { fontWeight: '600', fontSize: '14px', color: '#2d3748' },
  daySummary: { fontSize: '12px', color: '#718096' },
  lockBadge: { fontSize: '10px', fontWeight: '700', color: '#744210', background: '#fefcbf', padding: '2px 6px', borderRadius: '3px' },
  dayBody: {
    padding: '12px 14px', border: '1px solid #e2e8f0', borderTop: 'none',
    borderRadius: '0 0 6px 6px', marginBottom: '8px', background: '#fff',
  },
  caseListHeader: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    fontSize: '12px', fontWeight: '600', color: '#718096',
    padding: '4px 8px', marginBottom: '4px',
  },
  caseList: { maxHeight: '240px', overflowY: 'auto', border: '1px solid #edf2f7', borderRadius: '4px' },
  caseRow: {
    display: 'flex', alignItems: 'center', padding: '8px 10px',
    fontSize: '13px', color: '#4a5568', cursor: 'pointer',
    borderBottom: '1px solid #f7fafc',
  },
  caseRowAssigned: {
    background: '#ebf4ff', color: '#2b6cb0', fontWeight: '500',
  },
  caseRowAssignedGraded: {
    background: '#f0e6f0', color: '#6b2668', fontWeight: '600',
  },
  caseRowLocked: {
    cursor: 'not-allowed', opacity: 0.7,
  },
  gradeCheckbox: { marginRight: '10px', width: '16px', height: '16px', cursor: 'pointer' },
  gradeCheckboxDisabled: { cursor: 'not-allowed', opacity: 0.4 },
  noCases: { fontSize: '12px', color: '#a0aec0', fontStyle: 'italic', padding: '12px' },
};

export default function BatchManagementPage() {
  const [batches, setBatches] = useState([]);
  const [scenarios, setScenarios] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingBatch, setEditingBatch] = useState(null);
  const [formData, setFormData] = useState({ batch_number: '', status: 'active', days: makeEmptyDays() });
  const [expandedDay, setExpandedDay] = useState(null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [archiveTarget, setArchiveTarget] = useState(null);
  const [archiveConfirmText, setArchiveConfirmText] = useState('');
  // Day numbers (1..10) whose date check failed on the last Save attempt.
  // Renders a red border on the day header and date input until the user
  // enters a date there.
  const [dateErrorDays, setDateErrorDays] = useState(() => new Set());
  const modalCardRef = useRef(null);

  const today = todayAZString();

  useEffect(() => { loadData(); }, []);

  async function loadData() {
    setListLoading(true);
    try {
      const [batchData, scenarioData] = await Promise.all([getBatches(), getScenarios()]);
      setBatches(batchData.batches || []);
      setScenarios(scenarioData.scenarios || []);
    } catch {
      setError('Failed to load data.');
    } finally {
      setListLoading(false);
    }
  }

  function openCreateModal() {
    setEditingBatch(null);
    setFormData({ batch_number: '', status: 'active', days: makeEmptyDays() });
    setExpandedDay(null);
    setShowModal(true);
    setError('');
    setDateErrorDays(new Set());
  }

  function openEditModal(batch) {
    setEditingBatch(batch);
    const days = (batch.days && batch.days.length === NUM_DAYS)
      ? batch.days.map((d) => ({
          day_number: d.day_number,
          name: d.name,
          assigned_scenario_ids: [...(d.assigned_scenario_ids || [])],
          graded_scenario_ids: [...(d.graded_scenario_ids || [])],
          training_date: d.training_date || '',
        }))
      : makeEmptyDays();
    setFormData({ batch_number: batch.batch_number, status: batch.status, days });
    setExpandedDay(null);
    setShowModal(true);
    setError('');
    setDateErrorDays(new Set());
  }

  function closeModal() {
    setShowModal(false);
    setDateErrorDays(new Set());
  }

  function isDayLocked(day) {
    // Only lock on a batch that already exists (saved). During create the
    // user is still filling in dates and shouldn't be trapped by a typo.
    if (!editingBatch) return false;
    return !!(day.training_date && day.training_date <= today);
  }

  function getAssignedElsewhere(dayNumber) {
    const ids = new Set();
    for (const d of formData.days) {
      if (d.day_number === dayNumber) continue;
      for (const sid of d.assigned_scenario_ids) ids.add(sid);
    }
    return ids;
  }

  function toggleAssignScenario(dayIndex, scenarioId) {
    setFormData((prev) => {
      const day = prev.days[dayIndex];
      if (isDayLocked(day)) return prev;
      const isAssigned = day.assigned_scenario_ids.includes(scenarioId);
      const newDays = prev.days.map((d, i) => {
        if (i !== dayIndex) return d;
        if (isAssigned) {
          return {
            ...d,
            assigned_scenario_ids: d.assigned_scenario_ids.filter((id) => id !== scenarioId),
            graded_scenario_ids: d.graded_scenario_ids.filter((id) => id !== scenarioId),
          };
        }
        return { ...d, assigned_scenario_ids: [...d.assigned_scenario_ids, scenarioId] };
      });
      return { ...prev, days: newDays };
    });
  }

  function toggleGradeScenario(dayIndex, scenarioId) {
    setFormData((prev) => {
      const day = prev.days[dayIndex];
      if (isDayLocked(day)) return prev;
      if (!day.assigned_scenario_ids.includes(scenarioId)) return prev;
      const newDays = prev.days.map((d, i) => {
        if (i !== dayIndex) return d;
        const isGraded = d.graded_scenario_ids.includes(scenarioId);
        return {
          ...d,
          graded_scenario_ids: isGraded
            ? d.graded_scenario_ids.filter((id) => id !== scenarioId)
            : [...d.graded_scenario_ids, scenarioId],
        };
      });
      return { ...prev, days: newDays };
    });
  }

  function setDayTrainingDate(dayIndex, value) {
    setFormData((prev) => {
      const day = prev.days[dayIndex];
      if (isDayLocked(day)) return prev;
      const newDays = prev.days.map((d, i) => {
        if (i !== dayIndex) return d;
        return { ...d, training_date: value };
      });
      return { ...prev, days: newDays };
    });
    // Clear the red highlight as soon as a date is picked.
    if (value) {
      setDateErrorDays((prev) => {
        const dayNum = formData.days[dayIndex]?.day_number;
        if (!prev.has(dayNum)) return prev;
        const next = new Set(prev);
        next.delete(dayNum);
        return next;
      });
    }
  }

  function scrollModalToTop() {
    const el = modalCardRef.current;
    if (!el) return;
    try {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      el.scrollTop = 0;
    }
  }

  async function handleSave() {
    if (!formData.batch_number.trim()) {
      setError('Batch number is required.');
      setDateErrorDays(new Set());
      scrollModalToTop();
      return;
    }
    // A day with assigned cases must have a training date. Without it the
    // VA's portal can't date-gate visibility correctly, and trainees end up
    // either seeing cases they shouldn't or (per the prior bug) submitting
    // them prematurely. Block here so the misconfigured state never reaches
    // the backend.
    const missingDays = (formData.days || [])
      .filter((d) => (d.assigned_scenario_ids || []).length > 0
                     && !(d.training_date || '').trim());
    if (missingDays.length > 0) {
      const labels = missingDays.map((d) => `Day ${d.day_number}`);
      setError(
        `Training date is required for ${labels.join(', ')}. ` +
        `Either set a training date or remove the assigned cases from those days. ` +
        `The affected day${labels.length === 1 ? ' is' : 's are'} highlighted in red below.`
      );
      setDateErrorDays(new Set(missingDays.map((d) => d.day_number)));
      scrollModalToTop();
      return;
    }
    const batchName = `Batch ${formData.batch_number.trim()}`;
    setSaving(true);
    setError('');
    setDateErrorDays(new Set());

    try {
      const payload = {
        batch_number: formData.batch_number,
        name: batchName,
        status: formData.status,
        days: formData.days.map((d) => ({
          day_number: d.day_number,
          name: d.name,
          assigned_scenario_ids: d.assigned_scenario_ids,
          graded_scenario_ids: d.graded_scenario_ids,
          training_date: d.training_date || '',
        })),
      };

      const result = editingBatch
        ? await updateBatch(payload)
        : await createBatch(payload);

      if (result.error) {
        setError(result.error);
        scrollModalToTop();
      } else {
        setMessage(editingBatch ? 'Batch updated.' : `${batchName} created.`);
        closeModal();
        loadData();
      }
    } catch (e) {
      setError(`Failed to save: ${e.message || 'Network error.'}`);
      scrollModalToTop();
    } finally {
      setSaving(false);
    }
  }

  function promptDelete(batch) {
    setDeleteTarget(batch);
    setDeleteConfirmText('');
    setError('');
  }

  async function handleDelete() {
    if (!deleteTarget) return;
    setError('');
    try {
      const result = await deleteBatch(deleteTarget.batch_number);
      if (result.error) {
        setError(result.error);
      } else {
        setMessage(`Batch "${deleteTarget.name}" deleted.`);
        setDeleteTarget(null);
        setDeleteConfirmText('');
        loadData();
      }
    } catch (e) {
      setError(`Failed to delete: ${e.message || 'Network error.'}`);
    }
  }

  function promptArchive(batch) {
    setArchiveTarget(batch);
    setArchiveConfirmText('');
    setError('');
  }

  async function handleArchive() {
    if (!archiveTarget) return;
    setError('');
    try {
      const result = await archiveBatch(archiveTarget.batch_number);
      if (result.error) {
        setError(result.error);
      } else {
        setMessage(result.message || `Batch "${archiveTarget.name}" archive started.`);
        setArchiveTarget(null);
        setArchiveConfirmText('');
        loadData();
      }
    } catch (e) {
      setError(`Failed to archive: ${e.message || 'Network error.'}`);
    }
  }

  function batchTotalGrading(b) {
    return (b.days || []).reduce((s, d) => s + ((d.graded_scenario_ids || []).length), 0);
  }
  function batchTotalCases(b) {
    return (b.days || []).reduce((s, d) => s + (d.assigned_scenario_ids || []).length, 0);
  }
  function batchGradingDays(b) {
    return (b.days || []).filter((d) => (d.graded_scenario_ids || []).length > 0).length;
  }

  return (
    <div>
      <h1 style={styles.heading}>Batch Management</h1>
      {message && <div style={styles.success}>{message}</div>}
      {error && !showModal && <div style={styles.error}>{error}</div>}

      <div style={styles.toolbar}>
        <button style={styles.addBtn} onClick={openCreateModal}>+ New Batch</button>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Batch</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Cases</th>
            <th style={styles.th}>Grading</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {batches.map((b) => (
            <tr key={b.batch_number}>
              <td style={styles.td}>
                <div style={{ fontWeight: '600' }}>{b.name || b.batch_number}</div>
              </td>
              <td style={styles.td}>
                <span style={{
                  ...styles.badge,
                  ...(b.status === 'active' ? styles.badgeActive :
                      b.status === 'archiving' ? { background: '#fefcbf', color: '#975a16' } :
                      b.status === 'archived' ? { background: '#e2e8f0', color: '#718096' } :
                      b.status === 'archive_failed' ? { background: '#fed7d7', color: '#c53030' } :
                      styles.badgeClosed)
                }}>
                  {b.status === 'active' ? 'Active' : b.status === 'archiving' ? 'Archiving...' : b.status === 'archived' ? 'Archived' : b.status === 'archive_failed' ? 'Archive Failed' : 'Closed'}
                </span>
              </td>
              <td style={styles.td}>
                <span style={{ fontWeight: '600' }}>{b.total_cases != null ? b.total_cases : batchTotalCases(b)}</span>
                <span style={{ color: '#a0aec0', fontSize: '12px', marginLeft: '4px' }}>across 10 days</span>
              </td>
              <td style={styles.td}>
                <span style={{ fontWeight: '600' }}>{b.total_grading_count != null ? b.total_grading_count : batchTotalGrading(b)}</span>
                <span style={{ color: '#a0aec0', fontSize: '12px', marginLeft: '4px' }}>
                  ({batchGradingDays(b)} grading day{batchGradingDays(b) !== 1 ? 's' : ''})
                </span>
              </td>
              <td style={styles.td}>
                <button style={styles.actionBtn} onClick={() => openEditModal(b)}>Edit</button>
                {b.status !== 'archived' && b.status !== 'archiving' && (
                  <button style={{ ...styles.actionBtn, color: '#9C3D97', borderColor: '#9C3D97' }} onClick={() => promptArchive(b)}>
                    Archive
                  </button>
                )}
                <button style={{ ...styles.actionBtn, color: '#c53030', borderColor: '#feb2b2' }} onClick={() => promptDelete(b)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {listLoading && batches.length === 0 && (
            <tr><td style={{ ...styles.td, textAlign: 'center', color: '#718096' }} colSpan={5}>Loading batches...</td></tr>
          )}
          {!listLoading && batches.length === 0 && (
            <tr><td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }} colSpan={5}>No batches yet. Click "+ New Batch" to get started.</td></tr>
          )}
        </tbody>
      </table>

      {/* Create/Edit Modal */}
      {showModal && (
        <div style={styles.modal}>
          <div style={styles.modalCard} ref={modalCardRef}>
            <h2 style={styles.modalTitle}>{editingBatch ? 'Edit Batch' : 'Create New Batch'}</h2>

            {error && <div style={styles.error}>{error}</div>}

            <label style={styles.label}>
              Batch Number<span style={styles.required}>*</span>
            </label>
            <input
              style={{ ...styles.input, ...(editingBatch ? { background: '#f7fafc', color: '#a0aec0' } : {}) }}
              value={formData.batch_number}
              onChange={(e) => setFormData({ ...formData, batch_number: e.target.value })}
              placeholder="e.g., 120"
              disabled={!!editingBatch}
              autoFocus={!editingBatch}
            />

            {formData.batch_number && (
              <div style={{ marginTop: '8px', fontSize: '13px', color: '#718096' }}>
                Name: <strong>Batch {formData.batch_number}</strong>
              </div>
            )}

            <label style={styles.label}>Training Days</label>
            <div style={{ fontSize: '12px', color: '#718096', marginBottom: '10px' }}>
              Click a case to assign it to the day. Check the box to mark a case for grading.
              {editingBatch && ' Days with a past or present training date are locked.'}
            </div>

            {formData.days.map((day, idx) => {
              const isExpanded = expandedDay === idx;
              const assignedElsewhere = getAssignedElsewhere(day.day_number);
              const availableCases = scenarios.filter((s) => {
                const alreadyAssigned = day.assigned_scenario_ids.includes(s.id);
                if (alreadyAssigned) return true;
                if (assignedElsewhere.has(s.id)) return false;
                if (!s.has_grading_sheet) return false;
                if (day.training_date && s.suspense_date && day.training_date > s.suspense_date) {
                  return false;
                }
                return true;
              });
              const casesCount = day.assigned_scenario_ids.length;
              const gradedCount = day.graded_scenario_ids.length;
              const isGrading = gradedCount > 0;
              const locked = isDayLocked(day);
              const hasDateError = dateErrorDays.has(day.day_number);

              // On a missing-date validation error we highlight ONLY the date
              // field (below), not the whole day header - the header already
              // carries the purple "grading" highlight, so a full-row red was
              // visually noisy (Monday #11996712446).
              const headerStyle = {
                ...styles.dayHeader,
                ...(isGrading ? styles.dayHeaderGrading : {}),
                ...(locked ? styles.dayHeaderLocked : {}),
              };

              return (
                <div key={day.day_number}>
                  <div
                    style={headerStyle}
                    onClick={() => setExpandedDay(isExpanded ? null : idx)}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                      <span style={styles.dayName}>{day.name}</span>
                      <span style={styles.daySummary}>
                        {casesCount} case{casesCount !== 1 ? 's' : ''}
                        {isGrading ? `, ${gradedCount} graded` : ', practice'}
                      </span>
                      {locked && <span style={styles.lockBadge}>LOCKED</span>}
                      <input
                        type="date"
                        value={day.training_date || ''}
                        onChange={(e) => { e.stopPropagation(); setDayTrainingDate(idx, e.target.value); }}
                        onClick={(e) => e.stopPropagation()}
                        disabled={locked}
                        style={{
                          padding: '4px 8px',
                          border: hasDateError ? '2px solid #c53030' : '1px solid #e2e8f0',
                          borderRadius: '4px',
                          fontSize: '12px',
                          color: hasDateError ? '#c53030' : '#4a5568',
                          marginLeft: 'auto',
                          cursor: locked ? 'not-allowed' : 'auto',
                          background: hasDateError ? '#fff5f5' : '#fff',
                        }}
                      />
                    </div>
                    <span style={{ fontSize: '14px', color: '#a0aec0', marginLeft: '8px' }}>{isExpanded ? '\u25B2' : '\u25BC'}</span>
                  </div>

                  {isExpanded && (
                    <div style={styles.dayBody}>
                      <div style={styles.caseListHeader}>
                        <span>Click a case to assign it. Check the box to grade it.</span>
                        <span>{casesCount} assigned, {gradedCount} graded</span>
                      </div>
                      <div style={styles.caseList}>
                        {availableCases.length > 0 ? availableCases.map((s) => {
                          const isAssigned = day.assigned_scenario_ids.includes(s.id);
                          const isGraded = day.graded_scenario_ids.includes(s.id);
                          let rowStyle = { ...styles.caseRow };
                          if (isAssigned && isGraded) rowStyle = { ...rowStyle, ...styles.caseRowAssignedGraded };
                          else if (isAssigned) rowStyle = { ...rowStyle, ...styles.caseRowAssigned };
                          if (locked) rowStyle = { ...rowStyle, ...styles.caseRowLocked };

                          return (
                            <div
                              key={s.id}
                              style={rowStyle}
                              onClick={(e) => {
                                if (locked) return;
                                if (e.target.tagName === 'INPUT') return;
                                toggleAssignScenario(idx, s.id);
                              }}
                            >
                              <input
                                type="checkbox"
                                style={{
                                  ...styles.gradeCheckbox,
                                  ...((!isAssigned || locked) ? styles.gradeCheckboxDisabled : {}),
                                }}
                                checked={isGraded}
                                disabled={!isAssigned || locked}
                                onChange={() => toggleGradeScenario(idx, s.id)}
                                onClick={(e) => e.stopPropagation()}
                                title={!isAssigned ? 'Click the case row first to assign it' : (isGraded ? 'Click to stop grading' : 'Click to grade this case')}
                              />
                              {s.name}
                            </div>
                          );
                        }) : (
                          <div style={styles.noCases}>All cases are assigned to other days.</div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            <div style={{ marginTop: '12px', padding: '10px', background: '#f7fafc', borderRadius: '6px', fontSize: '13px', color: '#4a5568' }}>
              <strong>Summary:</strong>{' '}
              {formData.days.reduce((s, d) => s + d.assigned_scenario_ids.length, 0)} total cases,{' '}
              {formData.days.reduce((s, d) => s + d.graded_scenario_ids.length, 0)} graded across{' '}
              {formData.days.filter((d) => d.graded_scenario_ids.length > 0).length} grading day(s)
            </div>

            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={closeModal}>Cancel</button>
              <button
                style={{ ...styles.saveBtn, ...(saving ? styles.saveBtnDisabled : {}) }}
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? 'Saving...' : (editingBatch ? 'Update Batch' : 'Create Batch')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteTarget && (
        <div style={styles.modal}>
          <div style={{ ...styles.modalCard, width: '460px' }}>
            <h2 style={{ ...styles.modalTitle, color: '#c53030' }}>Delete {deleteTarget.name}?</h2>
            <div style={{
              background: '#fed7d7', color: '#9b2c2c', padding: '12px 14px',
              borderRadius: '6px', fontSize: '14px', fontWeight: '600',
              marginBottom: '16px', lineHeight: '1.45',
            }}>
              WARNING: this permanently deletes the batch, every grading result for every trainee in the batch, and every submitted PDF, graded HTML, and summary file in Azure storage. Once deleted it cannot be recovered. Files previously archived to SharePoint remain in SharePoint untouched.
            </div>
            <p style={{ fontSize: '14px', color: '#4a5568', marginBottom: '6px' }}>
              Type <strong>Delete</strong> to confirm:
            </p>
            <input
              style={{ ...styles.input, borderColor: deleteConfirmText === 'Delete' ? '#48bb78' : '#e2e8f0' }}
              value={deleteConfirmText}
              onChange={(e) => setDeleteConfirmText(e.target.value)}
              placeholder="Type Delete to confirm"
              autoFocus
            />
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => { setDeleteTarget(null); setDeleteConfirmText(''); }}>Cancel</button>
              <button
                style={{
                  ...styles.saveBtn,
                  background: deleteConfirmText === 'Delete' ? '#c53030' : '#e2e8f0',
                  color: deleteConfirmText === 'Delete' ? '#fff' : '#a0aec0',
                  cursor: deleteConfirmText === 'Delete' ? 'pointer' : 'not-allowed',
                }}
                onClick={handleDelete}
                disabled={deleteConfirmText !== 'Delete'}
              >
                Delete Batch
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Archive Confirmation Modal */}
      {archiveTarget && (
        <div style={styles.modal}>
          <div style={{ ...styles.modalCard, width: '440px' }}>
            <h2 style={{ ...styles.modalTitle, color: '#9C3D97' }}>Archive {archiveTarget.name}?</h2>
            <p style={{ fontSize: '14px', color: '#4a5568', marginBottom: '8px' }}>
              This will copy all grading outputs to SharePoint, verify the copy, then permanently remove all grading data from the dashboard. This cannot be undone.
            </p>
            <p style={{ fontSize: '14px', color: '#4a5568', marginBottom: '16px' }}>
              To confirm, type <strong>ARCHIVE BATCH</strong> below:
            </p>
            <input
              style={{ ...styles.input, borderColor: archiveConfirmText === 'ARCHIVE BATCH' ? '#48bb78' : '#e2e8f0' }}
              value={archiveConfirmText}
              onChange={(e) => setArchiveConfirmText(e.target.value)}
              placeholder="Type ARCHIVE BATCH to confirm"
              autoFocus
            />
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => { setArchiveTarget(null); setArchiveConfirmText(''); }}>Cancel</button>
              <button
                style={{
                  ...styles.saveBtn,
                  background: archiveConfirmText === 'ARCHIVE BATCH' ? '#9C3D97' : '#e2e8f0',
                  color: archiveConfirmText === 'ARCHIVE BATCH' ? '#fff' : '#a0aec0',
                  cursor: archiveConfirmText === 'ARCHIVE BATCH' ? 'pointer' : 'not-allowed',
                }}
                onClick={handleArchive}
                disabled={archiveConfirmText !== 'ARCHIVE BATCH'}
              >
                Archive Batch
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
